import { render } from "./AppDialog.vue?vue&type=template&id=32d4ce5a&ts=true"
import script from "./AppDialog.vue?vue&type=script&lang=ts"
export * from "./AppDialog.vue?vue&type=script&lang=ts"

import "./AppDialog.vue?vue&type=style&index=0&id=32d4ce5a&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__